import React from 'react'

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom'

import Page from '../Shared/Page'
import Error404 from '../Shared/Errors/404'
import Auth from '../Auth'
import Actions from '../Actions'
import Databases from '../Databases'
import Modals from '../Modals'
import OnboardingSubscribe from '../Subscriptions/Onboarding'
import Settings from '../Settings'
import Account from '../Account'
import AppLoader from './AppLoader'
import ProfileSetup from '../Users/ProfileSetup'

import './App.css'

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/login" component={Auth} />
        <Route path="/signup" component={Auth} />
        <Route path="/auth" component={Auth} />
        <Route path="/invitations" component={Auth} />
        <Route path="/databases/initial-setup" component={Databases} />
        <Route path="/databases/view-setup" component={Databases} />
        <Route path="/setup/profile" component={ProfileSetup} />
        <Route exact path="/databases/views/:viewId" component={Databases} />
        <Route
          exact
          path="/databases/views/:viewId/actions/:actionId"
          component={Databases}
        />
        <Route path="/subscribe" component={OnboardingSubscribe} />
        <Route
          render={() => (
            <Page>
              <AppLoader>
                <Switch>
                  <Route
                    exact
                    path="/"
                    render={() => <Redirect to="/databases" />}
                  />
                  <Route path="/databases" component={Databases} />
                  <Route path="/actions" component={Actions} />
                  <Route path="/settings" component={Settings} />
                  <Route path="/account" component={Account} />
                  <Route component={Error404} />
                </Switch>
              </AppLoader>
            </Page>
          )}
        />
      </Switch>
      <Modals />
    </Router>
  )
}

export default App
